const work = {
	forage: 'forage',
	craft: 'craft',
	fabricate: 'fabricate',
};

export default work;
